import { Component, h } from "preact";

export default class Hyperlink extends Component<{ value: any; data: any }> {
  public render() {
    return (
      <a
        href={this.props.data.hlink}
        style="text-decoration: underline; color: black;"
      >
        {this.props.value}
      </a>
    );
  }
}
